import { getMetaContent } from './meta';

/** @type {string[]} */
export const BACKGROUND_IMAGE_CONTENT_TYPES = JSON.parse(getMetaContent('workspace:background_image_content_types') || '[]');

const workspaceBackgroundUpdateQueues = new Map();
const pendingChatBackgroundActions = new Set();
const latestChatBackgroundActions = new Map();

export const beginChatBackgroundAction = (workspaceId, attachmentId) => {
  const key = `${workspaceId}:${attachmentId}`;
  if (pendingChatBackgroundActions.has(key)) return null;

  const actionId = Symbol();
  pendingChatBackgroundActions.add(key);
  latestChatBackgroundActions.set(workspaceId, actionId);

  return {
    isLatest: () => latestChatBackgroundActions.get(workspaceId) === actionId,
    finish: () => {
      pendingChatBackgroundActions.delete(key);
      if (latestChatBackgroundActions.get(workspaceId) === actionId) latestChatBackgroundActions.delete(workspaceId);
    },
  };
};

export const queueWorkspaceBackgroundUpdate = (workspaceId, update) => {
  const queuedUpdate = (workspaceBackgroundUpdateQueues.get(workspaceId) || Promise.resolve()).catch(() => null).then(update);
  workspaceBackgroundUpdateQueues.set(workspaceId, queuedUpdate);

  return queuedUpdate.finally(() => {
    if (workspaceBackgroundUpdateQueues.get(workspaceId) === queuedUpdate) workspaceBackgroundUpdateQueues.delete(workspaceId);
  });
};

export const canSetAttachmentAsChatBackground = ({ attachment, profile, isDirectMessage = false }) =>
  Boolean(
    attachment?.id &&
      profile?.role === 'admin' &&
      !isDirectMessage &&
      BACKGROUND_IMAGE_CONTENT_TYPES.includes(attachment?.metadata?.content_type),
  );
